import React from "react";
import LandingSection from "../section/LandingSection";
import StatisticsSection from "../section/StatisticsSection";
// import HomeSection from "../section/HomeSection";
import AboutSection from "../section/AboutSection";
import ObjectivesSection from "../section/ObjectivesSection";
import MaVideo from "../section/MaVideo";
import ServicesSection from "../section/ServicesSection";

export default function Home() {
  return (
    <>
      <LandingSection />
      <StatisticsSection />
      {/* <HomeSection /> */}
      <AboutSection />
      <MaVideo/>
      <ServicesSection />
      <ObjectivesSection />
    </>
  );
}
